/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/prop-types */
import React from 'react';
import { Link } from 'gatsby';
import { introStyle } from '../styles/global';
import Gallery from '../components/Gallery';
import Figure from '../components/Figure';
import Player from '../components/Player/Player';

export default {
  marks: {
    internalLink: ({ mark, children }) => {
      if (!mark.reference) return children;

      const {
        reference: { _type = undefined, slug = {} },
      } = mark;

      let to = '';

      switch (_type) {
        case 'advicePostOperation':
          to += '/conseils-postoperatoires';
          break;

        case 'advicePreOperation':
          to += '/conseils-preoperatoires';
          break;

        case 'service':
          to += '/services';
          break;

        default:
          break;
      }

      to += `/${slug.current}`;

      return <Link to={to}>{children}</Link>;
    },
    link: ({ mark, children }) => {
      const { blank, href } = mark;

      return blank ? (
        <a href={href} target='_blank' rel='noopener noreferrer'>
          {children}
        </a>
      ) : (
        <a href={href}>{children}</a>
      );
    },
  },
  types: {
    block(props) {
      switch (props.node.style) {
        case 'h1':
          return <h1>{props.children}</h1>;

        case 'h2':
          return <h2>{props.children}</h2>;

        case 'h3':
          return <h3>{props.children}</h3>;

        case 'h4':
          return <h4>{props.children}</h4>;

        case 'intro':
          return <p css={introStyle}>{props.children}</p>;

        default:
          return <p>{props.children}</p>;
      }
    },
    figure({ node, options }) {
      const { imageOptions } = options;

      return <Figure node={node} fluidConfig={imageOptions} />;
    },
    gallery({ node, options }) {
      const { imageOptions = {} } = options;

      return <Gallery nodes={node.images} imageOptions={imageOptions} />;
    },
    player({ node }) {
      return <Player node={node} />;
    },
  },
};
